<template>
  <div class="evaluate-wrapper backdrop">
    <div class="common">
      <div class="evaluate-textarea">
        <textarea v-model="cannt_finish" placeholder="请输入无法完成原因"></textarea>
      </div>
      <div class="evaluate-btn">
        <button @click="addComments">确认提交</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Reason',
  data () {
    return {
      access_token: '', // tob access_token
      cannt_finish: ''
    }
  },
  computed: {
    ...mapState(['villageId', 'repairId', 'userId'])
  },
  created () {
    this.getAccessToken()
  },
  methods: {
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 提交
    addComments () {
      let content = this.cannt_finish
      if (content === '') {
        this.$toast({
          message: '请输入无法完成原因',
          duration: 3000
        })
        return false
      }
      this.axios.post('/wechat/repair/repairClose', {
        village_member_id: this.userId,
        village_id: this.villageId,
        repair_id: this.repairId,
        content: content
      })
        .then((res) => {
          if (res.data.status === 1) {
            this.$toast({
              message: res.data.data.message,
              duration: 5000
            })
            this.$router.push({name: 'RepairDetail'})
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    }
  }
}
</script>
<style scoped>
.evaluate-textarea {
  display: flex;
  font-size: 14px;
}
.evaluate-textarea textarea {
  flex: 1;
  background-color: #f6f6f6;
  border: none;
  padding: 10px;
  outline: none;
}
.evaluate-btn {
  width: 100%;
  display: flex;
  position: absolute;
  left: 0;
  bottom: 36px;
}
.evaluate-btn button {
  flex: 1;
  margin: 0 15px;
  height: 45px;
  border-radius: 22px;
  border: none;
  background-color: #ff9a0a;
  color: #ffffff;
  letter-spacing: 2px;
  font-size: 16px;
  outline: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/Repair/Reason.vue